// extracted by mini-css-extract-plugin
export default {"PageEnd":"PageEnd_67Pv2"};